import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import { loadReport } from "../thunks/loadReportClientData";
import { MonthlyTradingReportData } from "../types";
import { setData } from "../monthlyTradeDataSlice";

export const useReportClientData = () => {
  const data = useSelector<StoreType, MonthlyTradingReportData[] | undefined>(
    (s) => s.data.reports.monthlyTrade.data
  );

  const dispatch = useDispatch();
  const dispatchLoadData = React.useCallback(() => dispatch(loadReport()), [
    dispatch,
  ]);

  const resetData = React.useCallback(() => {
    dispatch(setData(undefined));
  }, [dispatch]);

  return [data, dispatchLoadData, resetData] as [
    typeof data,
    typeof dispatchLoadData,
    typeof resetData
  ];
};
